<div class="p-payment-method-finance__item">
  <span class="u-visually-hidden" [innerHTML]="'alt.cup' | staticMsg"></span>
  <h3
    class="p-payment-method-finance__item-title p-payment-method-finance__item-title--m p-sub-column-layout01__list-item"
    [innerHTML]="'heading.cup' | staticMsg"
  ></h3>
  <p class="p-payment-method-finance__item-contents" [innerHTML]="'message.cupDescription' | staticMsg"></p>
  <span class="l-tab-menu01__menu-title">
    <span class="l-tab-menu01__menu-title-icon"
      ><img src="assets/images/logo_chinaUnionPay.png" width="88" height="33" alt="{{ 'alt.cup' | staticMsg }}"
    /></span>
  </span>
</div>
